export default function (id) {
    let window = 'checklist.acessorio'
    !this.$uloc.window.get(window) && this.$uloc.window.new({
        wid: window,
        title: id ? `Acessório #${id}` : 'Novo acessório',
        width: '500',
        height: '60%',
        minHeight: '500px',
        maxWidth: '900',
        backdrop: true,
        clickOutside: false,
        windowClass: 'erp-window',
        contentClass: 'overflow-hidden',
        props: {
            id
        }
    }, () => import('../../components/window/gerenciamento-checklist/ChecklistAcessorio.vue'))
        .then((wid) => {
            console.log(wid)
            this.$uloc.window.listen(wid, {
                update: (wid, val) => {
                    console.log('Atualizado: ', val)
                    this.load?.()
                }
            })
        }) // return wid
}
